import clsx from "clsx";
import React from "react";

interface Props {
    isSmall? : boolean
}

export function EmptyList(props : Props) {

    return (
        <div className={'empty-list flex flex-col items-center justify-center flex-grow m-0'}>
            <div className={clsx("font-medium text-neutral-800 text-center", {
                "lg:text-heading-sm text-heading-xs" : !props.isSmall,
                "text-heading-xs" : props.isSmall
            })}>
                Nessun risultato trovato
            </div>
            <div className={clsx("font-medium text-neutral-400", {
                "md:text-heading-xs lg:block hidden" : !props.isSmall,
                " text-text-sm md:text-text-md lg:block hidden leading-6" : props.isSmall
            })} style={{ textAlign: 'center' }}>La tua ricerca non ha prodotto risultati.</div>
        </div>
    );
}